export default "__VITE_ASSET__a1OdJ$PK__"